import React from 'react';
import { Route, Switch as RRDSwitch, useRouteMatch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import useAxiosReqAuthIntcpt from '../../web-app-components/hooks/useAxiosReqAuthIntcpt';
import { useAuthContext } from '../../web-app-components/components/AuthProvider';
import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';
import authClient from '../../clients/auth';
import SignInForm from '../../components/SignInForm';
import ProfileLayout from './ProfileLayout';
import ProfileHome from './ProfileHome';
import ProfilePrizes from './ProfilePrizes';

const axiosReqAuthIntcptConfig = {
  shouldExcludeUrl: (url) => url === endpoints.auth,
};

const UserProfile = ({ locale }) => {
  const { path } = useRouteMatch();
  const { enqueueSnackbar } = useSnackbar();
  const { tokenValid, signIn, state: { token } } = useAuthContext();

  useAxiosReqAuthIntcpt(axiosInstance, token, axiosReqAuthIntcptConfig);

  const handleSignInFormSubmit = async ({ username, password }) => {
    try {
      signIn(await authClient.auth(username, password));
      enqueueSnackbar('Sveiki!', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(
        'Nepavyko prisijungti. Įsitikinkite, kad prisijungimo duomenys teisingi ir bandykite dar kartą.',
        { variant: 'error' }
      );
    }
  };

  if (!tokenValid) {
    return (
      <ProfileLayout locale={locale} showGuestHint>
        <SignInForm onSubmit={handleSignInFormSubmit} />
      </ProfileLayout>
    );
  }

  return (
    <RRDSwitch>
      <Route exact path={path}>
        <ProfileHome locale={locale} />
      </Route>
      <Route path={`${path}/prizes`}>
        <ProfilePrizes locale={locale} basePath={path} />
      </Route>
    </RRDSwitch>
  );
};

export default UserProfile;
